import { motion } from 'framer-motion'
import './OrderBoard.css'
import OrderHeader from '../order/OrderHeader'
import PricingModule from '../order/PricingModule'
import UnifiedCheckout from '../order/UnifiedCheckout'
import OrderSummary from '../order/OrderSummary'

export default function OrderBoard() {
    return (
        <motion.div
            className="order-board"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
        >
            <OrderHeader />

            <div className="container">
                <div className="order-content">
                    <motion.div
                        className="pricing-section"
                        initial={{ x: -20, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        transition={{ delay: 0.2 }}
                    >
                        <PricingModule />
                    </motion.div>

                    <motion.div
                        className="order-sidebar"
                        initial={{ x: 20, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        transition={{ delay: 0.3 }}
                    >
                        <OrderSummary />
                    </motion.div>

                    <motion.div
                        className="checkout-section"
                        initial={{ x: -20, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        transition={{ delay: 0.4 }}
                    >
                        <UnifiedCheckout />
                    </motion.div>
                </div>
            </div>
        </motion.div>
    )
}
